import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fb270af"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "h-100",
  style: {"overflow-x":"hidden"}
}
const _hoisted_2 = { class: "main-div" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-div" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "lbl-title" }, "Setting approval route")
], -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label-title" }, "Drafter", -1 /* HOISTED */))
const _hoisted_5 = { class: "label-Display" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label-title" }, "SMC confirmer", -1 /* HOISTED */))
const _hoisted_7 = { class: "label-Display" }
const _hoisted_8 = { class: "label-change" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "confirmer-top" }, "Approver", -1 /* HOISTED */))
const _hoisted_10 = { class: "confirmer-top" }
const _hoisted_11 = { class: "label-change" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "confirmer-top" }, "Confirmer1 at Distributor", -1 /* HOISTED */))
const _hoisted_13 = { class: "label-Display-confirmer" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "confirmer-top" }, " : ", -1 /* HOISTED */))
const _hoisted_15 = { class: "confirmer-line" }
const _hoisted_16 = { class: "label-change" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "confirmer-top" }, "Confirmer2 at Distributor", -1 /* HOISTED */))
const _hoisted_19 = { class: "label-Display-confirmer" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "confirmer-top" }, " : ", -1 /* HOISTED */))
const _hoisted_21 = { class: "confirmer-line" }
const _hoisted_22 = { class: "label-change" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "confirmer-top" }, "Confirmer3 at Distributor", -1 /* HOISTED */))
const _hoisted_26 = { class: "label-Display-confirmer" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "confirmer-top" }, " : ", -1 /* HOISTED */))
const _hoisted_28 = { class: "confirmer-line" }
const _hoisted_29 = { class: "label-change" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = ["disabled"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "confirmer-top" }, "Confirmer4 at Distributor", -1 /* HOISTED */))
const _hoisted_33 = { class: "label-Display-confirmer" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "confirmer-top" }, " : ", -1 /* HOISTED */))
const _hoisted_35 = { class: "confirmer-line" }
const _hoisted_36 = { class: "label-change" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "confirmer-top" }, "Confirmer5 at Distributor", -1 /* HOISTED */))
const _hoisted_40 = { class: "label-Display-confirmer" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "confirmer-top" }, " : ", -1 /* HOISTED */))
const _hoisted_42 = { class: "confirmer-line" }
const _hoisted_43 = { class: "label-change" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = ["disabled"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "confirmer-top" }, "Approver at Distributor", -1 /* HOISTED */))
const _hoisted_47 = { class: "label-Display-confirmer" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "confirmer-top" }, " : ", -1 /* HOISTED */))
const _hoisted_49 = { class: "confirmer-line" }
const _hoisted_50 = { class: "label-change" }
const _hoisted_51 = { colspan: "4" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = {
  class: "modal fade",
  id: "showModal",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true"
}
const _hoisted_54 = { class: "modal-dialog modal-dialog-scrollable modal-lg" }
const _hoisted_55 = { class: "modal-content" }
const _hoisted_56 = { class: "modal-header" }
const _hoisted_57 = {
  class: "modal-title",
  id: "showModalLabel"
}
const _hoisted_58 = {
  class: "modal-body",
  id: "modal-body",
  style: {"text-align":"left"}
}
const _hoisted_59 = { class: "row-div" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lbl-Search-Left" }, "User ID", -1 /* HOISTED */))
const _hoisted_61 = {
  id: "tbldiv",
  class: "tbl-div"
}
const _hoisted_62 = /*#__PURE__*/_createStaticVNode("<div class=\"tblTitle-div\" style=\"width:calc(100% - 16px);\" data-v-5fb270af><table id=\"tblIssueSalesNote\" class=\"w-100\" data-v-5fb270af><tr data-v-5fb270af><td style=\"width:4%;\" data-v-5fb270af></td><th style=\"width:28%;\" data-v-5fb270af>User ID</th><th style=\"width:40%;\" data-v-5fb270af>Name</th><th style=\"width:28%;\" data-v-5fb270af>Station CD</th></tr></table></div>", 1)
const _hoisted_63 = {
  id: "tblbodydiv",
  class: "tblbody-div"
}
const _hoisted_64 = {
  id: "tblIssueSalesNoteDetail",
  class: "w-100"
}
const _hoisted_65 = { id: "tbltbody" }
const _hoisted_66 = { style: {"width":"4%"} }
const _hoisted_67 = ["value", "onChange"]
const _hoisted_68 = { style: {"width":"28%","text-align":"left"} }
const _hoisted_69 = { style: {"width":"40%"} }
const _hoisted_70 = { style: {"width":"28%"} }
const _hoisted_71 = { class: "modal-footer" }
const _hoisted_72 = ["disabled"]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  id: "hidbtn",
  name: "hidbtn",
  value: "S"
}, null, -1 /* HOISTED */))
const _hoisted_74 = {
  key: 1,
  class: "h-100",
  style: {"overflow-x":"hidden"}
}
const _hoisted_75 = { class: "main-div" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-div" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "lbl-title" }, "Circulation Start")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.btnFlag == '')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode($setup["Navigation"]),
        _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
        _createVNode($setup["Alert"], {
          alertMessage: $setup.alertMessage,
          alertState: $setup.alertState
        }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
        _createVNode($setup["SalesNoteHeaderNavigation"]),
        _createVNode($setup["SalesNoteLinkNavigation"]),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, [
            _createElementVNode("table", null, [
              _createElementVNode("tr", null, [
                _hoisted_4,
                _createElementVNode("td", _hoisted_5, " : " + _toDisplayString($setup.store.getters.givenName + " " + $setup.store.getters.familyName + " (" + $setup.store.getters.cognitoUserName +")"), 1 /* TEXT */)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_6,
                _createElementVNode("td", _hoisted_7, " : " + _toDisplayString($setup.smcConfirmerId), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_8, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "ChangeC",
                    name: "ChangeC",
                    class: "btn btn-primary add text-center",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#showModal",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showModal('CONFIRMER')))
                  }, "Change")
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "ClearC",
                    name: "ClearC",
                    class: "btn btn-primary add text-center",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.btnClear('CONFIRMER')))
                  }, "CLEAR")
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_9,
                _createElementVNode("td", _hoisted_10, " : " + _toDisplayString($setup.approverId), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_11, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "ChangeA",
                    name: "Change",
                    class: "btn btn-primary add text-center",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#showModal",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showModal('APPROVER')))
                  }, "Change")
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "ClearA",
                    name: "Clear",
                    class: "btn btn-primary add text-center",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.btnClear('APPROVER')))
                  }, "CLEAR")
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_12,
                _createElementVNode("td", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("span", _hoisted_15, _toDisplayString($setup.distributorConfirmer1Id), 1 /* TEXT */)
                ]),
                _createElementVNode("td", _hoisted_16, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "Change1",
                    name: "Change1",
                    class: "btn btn-primary add text-center",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#showModal",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.showModal('CONFIRMER1')))
                  }, "Change")
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "Clear1",
                    name: "Clear1",
                    disabled: $setup.Clear1disable,
                    class: "btn btn-primary add text-center",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.btnClear('CONFIRMER1')))
                  }, "CLEAR", 8 /* PROPS */, _hoisted_17)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_18,
                _createElementVNode("td", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("span", _hoisted_21, _toDisplayString($setup.distributorConfirmer2Id), 1 /* TEXT */)
                ]),
                _createElementVNode("td", _hoisted_22, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "Change2",
                    name: "Change2",
                    disabled: $setup.Change2disable,
                    class: "btn btn-primary add text-center",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#showModal",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.showModal('CONFIRMER2')))
                  }, "Change", 8 /* PROPS */, _hoisted_23)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "Clear2",
                    name: "Clear2",
                    disabled: $setup.Clear2disable,
                    class: "btn btn-primary add text-center",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.btnClear('CONFIRMER2')))
                  }, "CLEAR", 8 /* PROPS */, _hoisted_24)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_25,
                _createElementVNode("td", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("span", _hoisted_28, _toDisplayString($setup.distributorConfirmer3Id), 1 /* TEXT */)
                ]),
                _createElementVNode("td", _hoisted_29, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "Change3",
                    name: "Change3",
                    disabled: $setup.Change3disable,
                    class: "btn btn-primary add text-center",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#showModal",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.showModal('CONFIRMER3')))
                  }, "Change", 8 /* PROPS */, _hoisted_30)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "Clear3",
                    name: "Clear3",
                    disabled: $setup.Clear3disable,
                    class: "btn btn-primary add text-center",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.btnClear('CONFIRMER3')))
                  }, "CLEAR", 8 /* PROPS */, _hoisted_31)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_32,
                _createElementVNode("td", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("span", _hoisted_35, _toDisplayString($setup.distributorConfirmer4Id), 1 /* TEXT */)
                ]),
                _createElementVNode("td", _hoisted_36, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "Change4",
                    name: "Change4",
                    disabled: $setup.Change4disable,
                    class: "btn btn-primary add text-center",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#showModal",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.showModal('CONFIRMER4')))
                  }, "Change", 8 /* PROPS */, _hoisted_37)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "Clear4",
                    name: "Clear4",
                    disabled: $setup.Clear4disable,
                    class: "btn btn-primary add text-center",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.btnClear('CONFIRMER4')))
                  }, "CLEAR", 8 /* PROPS */, _hoisted_38)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_39,
                _createElementVNode("td", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("span", _hoisted_42, _toDisplayString($setup.distributorConfirmer5Id), 1 /* TEXT */)
                ]),
                _createElementVNode("td", _hoisted_43, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "Change5",
                    name: "Change5",
                    disabled: $setup.Change5disable,
                    class: "btn btn-primary add text-center",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#showModal",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.showModal('CONFIRMER5')))
                  }, "Change", 8 /* PROPS */, _hoisted_44)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "Clear5",
                    name: "Clear5",
                    disabled: $setup.Clear5disable,
                    class: "btn btn-primary add text-center",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.btnClear('CONFIRMER5')))
                  }, "CLEAR", 8 /* PROPS */, _hoisted_45)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_46,
                _createElementVNode("td", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("span", _hoisted_49, _toDisplayString($setup.distributorApproverId), 1 /* TEXT */)
                ]),
                _createElementVNode("td", _hoisted_50, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "ChangeD",
                    name: "ChangeD",
                    class: "btn btn-primary add text-center",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#showModal",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.showModal('DISTRIBUTER')))
                  }, "Change")
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "ClearD",
                    name: "ClearD",
                    class: "btn btn-primary add text-center",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.btnClear('DISTRIBUTER')))
                  }, "CLEAR")
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_51, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "StartID",
                    disabled: $setup.Ketteidisable,
                    class: "btn btn-primary btn-circulation",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.startConfirmationProcess()))
                  }, "Start Confirmation Process", 8 /* PROPS */, _hoisted_52)
                ])
              ])
            ])
          ])
        ]),
        _createCommentVNode(" Modal "),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("h5", _hoisted_57, _toDisplayString($setup.modalSubject[0]), 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.goClose()))
                })
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _withDirectives(_createElementVNode("input", {
                    maxlength: "20",
                    class: "txt-userid",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.txtUserId) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.txtUserId]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary text-center btn-search",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.goDetailSearch()))
                  }, "Search")
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _hoisted_62,
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("table", _hoisted_64, [
                      _createElementVNode("tbody", _hoisted_65, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.modalBody, (info, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_66, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                value: info.userId,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.isChecked) = $event)),
                                onChange: ($event: any) => ($setup.chkCheckEvent(info))
                              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_67), [
                                [_vModelRadio, $setup.isChecked]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_68, _toDisplayString(info.userId), 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_69, _toDisplayString(info.userName), 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_70, _toDisplayString(info.stationCode_id), 1 /* TEXT */)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("button", {
                  type: "button",
                  disabled: $setup.isCheckedOK,
                  class: "btn",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.goOK()))
                }, " OK ", 8 /* PROPS */, _hoisted_72)
              ])
            ])
          ])
        ]),
        _hoisted_73
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_74, [
        _createVNode($setup["Navigation"]),
        _createVNode($setup["Alert"], {
          alertMessage: $setup.alertMessage,
          alertState: $setup.alertState
        }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
        _createVNode($setup["SalesNoteHeaderNavigation"]),
        _createVNode($setup["SalesNoteLinkNavigation"]),
        _createElementVNode("div", _hoisted_75, [
          _hoisted_76,
          _createElementVNode("p", null, "SEND EMAIL TO " + _toDisplayString($setup.store.getters.givenName + " " + $setup.store.getters.familyName) + " ," + _toDisplayString($setup.distributorApproverName), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-exit",
            onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.btnExit()))
          }, " EXIT ")
        ])
      ]))
}